import Vue from 'vue'
import { MutationTree } from 'vuex'
import { ScriptPageState } from './state'
import { ScriptCardResponse } from '@/models/scripts'
import { CardVariant } from '@/constants/scripts'

export enum ScriptPageMutationTypes {
  Preview = '[Script Page Mutation] Preview',
  SetCard = '[Script Page Mutation] Set Card',
  SetVariant = '[Script Page Mutation] Set Variant',
}

export type ScriptPagePreviewMutationPayload = {
  scriptId: string
}

export type ScriptPageSetCardMutationPayload = {
  card: ScriptCardResponse
}

export const mutations: MutationTree<ScriptPageState> = {
  [ScriptPageMutationTypes.Preview](
    state,
    payload: ScriptPagePreviewMutationPayload,
  ) {
    const { scriptId } = payload

    state.scriptId = scriptId
    state.variant = CardVariant.A
  },

  [ScriptPageMutationTypes.SetCard](
    state,
    payload: ScriptPageSetCardMutationPayload,
  ) {
    const { card } = payload
    const { id, num, name } = card

    const history = state.history || []
    const oldIndex = history.findIndex(h => h.card === num)
    const tempHistory = oldIndex < 0 ? history : history.slice(0, oldIndex)

    state.cardNum = num
    state.history = tempHistory.concat({
      step: tempHistory.length + 1,
      card: num,
      name,
      opt: null,
    })

    Vue.set(state.cards, id, card)
    state.cardId = id
  },

  [ScriptPageMutationTypes.SetVariant](state, payload: CardVariant) {
    state.variant = payload
  },
}
